module.exports = __webpack_public_path__ + "images/emoji/camel.4ae2a813c90852c362d6.png";